export const ACTIVE = 'active';
export const PAYOUTS_SUSPENDED = 'payouts suspended';
